import { render, staticRenderFns } from "./PartialPayment.vue?vue&type=template&id=56798462&"
import script from "./PartialPayment.vue?vue&type=script&lang=js&"
export * from "./PartialPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports